import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../App';
import Sidebar from '../components/Sidebar';

const API = 'https://cctvapi.shopkwality.in/api';

const EnquiryDetail = () => {
  const { id } = useParams();
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  
  const [enquiry, setEnquiry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('');

  useEffect(() => {
    fetchEnquiry();
  }, [id]);

  const fetchEnquiry = async () => {
    try {
      const res = await axios.get(`${API}/enquiries/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEnquiry(res.data);
      setStatus(res.data.status);
    } catch (err) {
      console.error('Failed to load enquiry', err);
      alert('Failed to load enquiry');
      navigate('/enquiries');
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (newStatus) => {
    try {
      await axios.patch(`${API}/enquiries/${id}`, 
        { status: newStatus },
        { headers: { Authorization: `Bearer ${token}` }}
      );
      setStatus(newStatus);
      alert('Status updated successfully');
    } catch (err) {
      alert('Failed to update status');
    }
  };

  const createQuotation = () => {
    // Map enquiry items to quotation format with proper product names
    const mappedItems = (enquiry.items || []).map(item => ({
      product_id: item.product_id || null,
      name: item.product?.name || item.product_name || '',
      image: item.product?.images?.[0]?.image || null,
      quantity: Number(item.quantity) || 1,
      unit_price: Number(item.product?.price || item.unit_price || 0),
      gst_percent: item.gst_percent ?? 18
    }));

    navigate('/quotations/new', {
      state: {
        customerName: enquiry.customer_name,
        customerMobile: enquiry.customer_mobile,
        items: mappedItems
      }
    });
  };

  if (loading) return <div className="loading-container"><div className="spinner"></div></div>;
  if (!enquiry) return <div>Enquiry not found</div>;

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-main">
        <div className="page-header">
          <div className="container">
            <h1 className="page-title">Enquiry Detail</h1>
          </div>
        </div>
        <div className="container">
          <div className="card">
            <div className="card-header">
              <h2>Customer Information</h2>
            </div>
            <div className="grid grid-2">
              <div className="form-group">
                <label className="form-label">Name</label>
                <p className="form-value">{enquiry.customer_name}</p>
              </div>
              <div className="form-group">
                <label className="form-label">Mobile</label>
                <p className="form-value">{enquiry.customer_mobile}</p>
              </div>
              {enquiry.customer_email && (
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <p className="form-value">{enquiry.customer_email}</p>
                </div>
              )}
              <div className="form-group">
                <label className="form-label">Status</label>
                <select 
                  value={status} 
                  onChange={(e) => updateStatus(e.target.value)}
                  className="form-select"
                >
                  <option value="new">New</option>
                  <option value="in_progress">In Progress</option>
                  <option value="quoted">Quoted</option>
                  <option value="closed">Closed</option>
                </select>
              </div>
            </div>
            {enquiry.message && (
              <div className="form-group">
                <label className="form-label">Message</label>
                <p className="form-value">{enquiry.message}</p>
              </div>
            )}
          </div>

          {enquiry.items && enquiry.items.length > 0 && (
            <div className="card">
              <div className="card-header">
                <h2>Requested Items</h2>
              </div>
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Quantity</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {enquiry.items.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.product?.name || item.product_name || 'Unknown'}</td>
                        <td>{item.quantity}</td>
                        <td>₹{item.product?.price || item.unit_price || 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div style={{ marginTop: '24px', display: 'flex', gap: '12px' }}>
            <button onClick={createQuotation} className="btn btn-primary">
              Create Quotation
            </button>
            <button onClick={() => navigate('/enquiries')} className="btn btn-secondary">
              Back to List
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnquiryDetail;